import * as React from 'react';
import { 
    MenuItem, 
    Tooltip, 
    Button, 
    Avatar, 
    Container, 
    Typography, 
    Menu,
    IconButton,
    Box,
    AppBar,
    Toolbar,
    SvgIcon,
} from '@mui/material'

import MenuIcon from '@mui/icons-material/Menu';
import AdbIcon from '@mui/icons-material/Adb';
import { auth, db } from '../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { async } from '@firebase/util';
import { collection, getDocs } from 'firebase/firestore';
import logoByN from '../Media/logoByN.svg'


const Navbar = (props) => {

    const {firebaseUser} = props;

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [esAdmin, setEsAdmin] = useState(false);
    const [administradores, setAdministradores] = useState([]);

    useEffect(() => {
        obtenerAdministradores();
    }, [])
    
    const obtenerAdministradores = async() =>{
        let arrayAux = [];

        const querySnapshot = await getDocs(collection(db, 'usuarios'))
        querySnapshot.docs.map( (doc) =>{
            if(doc.data().rol === 'admin' || doc.data().rol === 'super'){
                arrayAux.push(doc.data().uid);
            }
        })
        setAdministradores(arrayAux);

    }
    
    const navigate = useNavigate();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const cerrarSesion = () =>{
        handleCloseUserMenu();
        auth.signOut()
            .then(() =>{
                navigate('/login')
            })
    }

    

    return (
        <AppBar position="static">
        <Container maxWidth="xl">
            <Toolbar disableGutters>

            {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
            <SvgIcon>
                <path
                    version="1.0" 
                    xmlns="http://www.w3.org/2000/svg"
                    width="458.000000pt" 
                    height="338.000000pt" 
                    viewBox="0 0 458.000000 338.000000"
                    preserveAspectRatio="xMidYMid meet"
                />
            </SvgIcon>
            <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
                }}
            >
                INICIO
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                >
                    <MenuIcon />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                    }}
                >
                    
                    <MenuItem onClick={handleCloseNavMenu}>
                        {/* <Link href="/" >
                            Inicio
                        </Link> */}
                        <Typography onClick={()=>{navigate('/')}}>
                            Inicio
                        </Typography>
                    </MenuItem>

                    <MenuItem onClick={handleCloseNavMenu}>
                        {/* <Link href="/lienzo" >
                            Lienzo
                        </Link> */}
                        <Typography onClick={()=>{navigate('/lienzo')}}>
                            Crear Diagrama
                        </Typography>
                    </MenuItem>

                    {
                        firebaseUser !== null ? 
                        (
                                <MenuItem onClick={handleCloseNavMenu}>
                                    <Typography onClick={()=>{navigate('/diagramas')}}>
                                        Mis Diagramas
                                    </Typography>
                                </MenuItem>
                        ):(null)
                    }
                    {
                        firebaseUser !== null ? 
                        (
                                <MenuItem onClick={handleCloseNavMenu}>
                                    <Typography onClick={()=>{navigate('/colecciones')}}>
                                        Mis Colecciones
                                    </Typography>
                                </MenuItem>
                        ):(null)
                    }
                    { firebaseUser !== null && administradores.includes(firebaseUser.uid) ?
                        ( 
                            <MenuItem  onClick={handleCloseNavMenu}>
                                <Typography onClick={()=>{navigate('/admin')}}>
                                    Admin
                                </Typography>
                            </MenuItem>)
                        :
                        (null)
                    }
                    
                    
                    
                    
                
                </Menu>
            </Box>

            <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
            
            <Typography
                variant="h5"
                noWrap
                component="a"
                href="/"
                sx={{
                    mr: 2,
                    display: { xs: 'flex', md: 'none' },
                    flexGrow: 1,
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.1rem',
                    color: 'inherit',
                    textDecoration: 'none',
                }}
            >
                GEMM
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                <Button /* href='/lienzo' */ onClick={()=>{navigate('/lienzo')}} sx={{ my: 2, color: 'white', display: 'block' }}>
                    <Typography  variant='button'>
                        Crear Diagrama
                    </Typography>
                </Button>

                {
                    firebaseUser !== null ? 
                    (
                        <Button /* href='/diagramas' */ onClick={()=>{navigate('/diagramas')}} sx={{ my: 2, color: 'white', display: 'block' }}>
                            <Typography  variant='button'>
                                Mis Diagramas
                            </Typography>
                        </Button>

                    )
                    :
                    (null)
                }
                {
                    firebaseUser !== null ? 
                    (
                        <Button /* href='/colecciones' */ onClick={()=>{navigate('/colecciones')}} sx={{ my: 2, color: 'white', display: 'block' }}>
                            <Typography  variant='button'>
                                Mis Colecciones
                            </Typography>
                        </Button>         
                    )
                    :
                    (null)
                }
                {
                    firebaseUser !== null && administradores.includes(firebaseUser.uid) ? (
                        <Button /* href='/admin' */ onClick={()=>{navigate('/admin')}} sx={{ my: 2, color: 'white', display: 'block' }} defaultValue='admin'>
                            <Typography  variant='button'>
                                Admin Dashboard
                            </Typography>
                        </Button>
                    ):(null)
                }
                
            </Box>

            
            {
                firebaseUser !== null ? 
                (
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Perfil / Salir">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar>{firebaseUser.email.charAt(0).toUpperCase()}</Avatar>
                            </IconButton>
                            
                        </Tooltip>

                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >

                        
                            <MenuItem  onClick={handleCloseUserMenu}>
                                <Typography onClick={()=>{navigate('/perfil')}}>
                                    Perfil
                                </Typography>
                            </MenuItem>

                            <MenuItem  onClick={cerrarSesion}>
                                <Typography textAlign="center"> Salir </Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                ):
                (
                    <Box sx={{ flexGrow: 0 }}>
                        <MenuItem  onClick={()=>{navigate('/login')}}>
                            <Typography textAlign="center"> Login </Typography>
                        </MenuItem>
                    </Box>
                )
                
            }
            
            </Toolbar>
        </Container>
        </AppBar>
    );
};

export default Navbar;
